export const obtenerZonaHorariaPorPais = (paisId: number | null | undefined): string => {
    switch (paisId) {
        case 1:
            return "America/Bogota"; // Colombia
        case 2:
            return "America/Panama"; // Panamá
        case 3:
            return "America/Costa_Rica"; // Costa Rica
        default:
            return "America/Bogota"; // Fallback
    }
};

export const obtenerNombrePaisPorId = (paisId: number | null | undefined): string => {
    switch (paisId) {
        case 1: return "Colombia";
        case 2: return "Panamá";
        case 3: return "Costa Rica";
        default: return "Colombia";
    }
};
